"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseCloudInfo = void 0;
var parseCloudInfo = function (dataView) {
    try {
        var bsOn = dataView === null || dataView === void 0 ? void 0 : dataView.getUint8(4);
        var powerLevel = dataView === null || dataView === void 0 ? void 0 : dataView.getUint8(0);
        var bsPowerLevel = dataView === null || dataView === void 0 ? void 0 : dataView.getUint8(3);
        var actualPowerLevel = bsOn ? bsPowerLevel : powerLevel;
        return {
            powerLevel: actualPowerLevel,
            batterySavingEnabled: dataView === null || dataView === void 0 ? void 0 : dataView.getUint8(1),
            batterySavingThresholdValue: dataView === null || dataView === void 0 ? void 0 : dataView.getUint8(2),
            batterySavingPowerLevel: dataView === null || dataView === void 0 ? void 0 : dataView.getUint8(3),
            batterySavingOn: dataView === null || dataView === void 0 ? void 0 : dataView.getUint8(4)
        };
    }
    catch (_a) {
        return {
            powerLevel: dataView === null || dataView === void 0 ? void 0 : dataView.getUint8(0),
        };
    }
};
exports.parseCloudInfo = parseCloudInfo;
